(function () {
  'use strict';

  angular.module('app.attendance-analytics.teacher-comparisons', []);

})();
